import { useState } from "react";
import { Instagram, Menu, X } from "lucide-react";

const LINKS = [
  { label: "Home", href: "#top" },
  { label: "Projects", href: "#portfolio" },
  { label: "Services", href: "#services" },
  { label: "Pricing", href: "#pricing" },
];

function RollText({ text }) {
  return (
    <span className="inline-flex" aria-label={text}>
      {text.split("").map((ch, i) => (
        <span key={i} aria-hidden className="roll-letter">
          <span style={{ transitionDelay: `${i * 35}ms` }}>{ch}</span>
          <span style={{ transitionDelay: `${i * 35}ms` }}>{ch}</span>
        </span>
      ))}
    </span>
  );
}

export function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header data-testid="site-navbar" className="fixed top-0 left-0 right-0 z-50 bg-[#090A0F]/85 backdrop-blur-md border-b border-amber-500/10">
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-14 py-3 flex items-center justify-between">
        <div className="flex items-center gap-6">
          <a href="#top" data-testid="nav-home-logo-btn" aria-label="Home"
            className="absolute left-1/2 -translate-x-1/2 md:static md:left-auto md:translate-x-0 flex items-center rounded-md p-1 hover:bg-amber-400/5 transition-all duration-300 hover:[filter:drop-shadow(0_0_12px_rgba(212,175,55,0.45))]">
            <span className="relative block w-fit">
              <img src="/assets/logo-icon.png" alt="M&M Productions — Home" className="h-8 sm:h-9 w-auto" />
              <img src="/assets/logo-icon.png" alt="" aria-hidden className="energy-sweep" />
            </span>
          </a>
          <nav className="hidden md:flex items-center gap-8 md:absolute md:left-1/2 md:-translate-x-1/2">
            {LINKS.map((l, i) => (
              <span key={l.label} className="flex items-center gap-8">
                {i > 0 && <span className="text-sm text-slate-300/60 select-none">/</span>}
                <a data-testid={`nav-link-${l.label.toLowerCase()}`} href={l.href}
                  className="roll-hover nav-link-anim text-sm text-slate-300 hover:text-amber-300 transition-colors duration-300 tracking-wide">
                  <RollText text={l.label} />
                </a>
              </span>
            ))}
          </nav>
        </div>

        <div className="flex items-center gap-3">
          <a href="https://www.instagram.com/mandmproductionswa/" target="_blank" rel="noopener noreferrer"
            data-testid="nav-instagram-btn" aria-label="M&M Productions on Instagram"
            className="btn-fill btn-fill-ig ig-glow ig-mobile-left flex items-center justify-center notched-sm border border-pink-500/40 bg-transparent p-2.5 md:p-2 text-pink-400 hover:text-white transition-colors duration-300">
            <Instagram className="h-5 w-5 md:h-4 md:w-4" />
          </a>
          <a href="#contact" data-testid="nav-get-started-btn"
            className="btn-fill notched-sm hidden sm:inline-flex items-center border border-amber-400/40 bg-transparent px-5 py-2 text-sm font-semibold text-amber-300 hover:text-black hover:shadow-[0_0_25px_rgba(212,175,55,0.35)] transition-[color,box-shadow] duration-300">
            Get in Touch
          </a>
          <button data-testid="nav-mobile-menu-btn" onClick={() => setOpen(!open)} className="md:hidden p-2.5 text-slate-300" aria-label="Menu">
            {open ? <X className="h-7 w-7" /> : <Menu className="h-7 w-7" />}
          </button>
        </div>
      </div>

      {open && (
        <nav data-testid="nav-mobile-menu" className="md:hidden border-t border-white/5 bg-[#090A0F]/95 px-6 py-6 flex flex-col items-center text-center gap-5">
          {LINKS.map((l) => (
            <a key={l.label} data-testid={`nav-mobile-link-${l.label.toLowerCase()}`} href={l.href} onClick={() => setOpen(false)}
              className="roll-hover nav-link-anim text-sm text-slate-300 hover:text-amber-300 transition-colors duration-300 tracking-wide">
              <RollText text={l.label} />
            </a>
          ))}
          <a href="#contact" onClick={() => setOpen(false)} data-testid="nav-mobile-get-started-btn"
            className="btn-fill notched-sm inline-flex w-fit items-center border border-amber-400/40 bg-transparent px-5 py-2 text-sm font-semibold text-amber-300 hover:text-black hover:shadow-[0_0_25px_rgba(212,175,55,0.35)] transition-[color,box-shadow] duration-300">
            Get in Touch
          </a>
        </nav>
      )}
    </header>
  );
}
